import { delay } from '@/common/services/delay';
function isRetryableError(e, retryable) {
    if (!retryable)
        throw e;
    // For example, check for specific error types, HTTP status codes, etc.
    return !!e; // Retry all errors here
}
export async function retry(fn, options = {}) {
    const { retries = 3, factor = 2, minTimeout = 100, maxTimeout = 1000, randomize = true, retryable = true, } = options;
    let attempt = 0;
    let timeout = minTimeout;
    while (attempt <= retries) {
        try {
            return await fn();
        }
        catch (e) {
            if (!retryable && !isRetryableError(e, retryable)) {
                throw e;
            }
            // Exponential backoff
            timeout = Math.min(timeout * factor, maxTimeout);
            if (randomize) {
                timeout = Math.random() * (timeout - timeout / 2) + timeout / 2;
            }
            await delay(timeout);
            attempt++;
        }
    }
    throw new Error(`Failed after ${retries} retries`);
}
export default retry;
